import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { PdftEditorComponent } from './pdft-editor/pdft-editor.component';
import { PdftHistoryViewerComponent } from './pdft-history-viewer/pdft-history-viewer.component';
import { SelectSymbolDialogComponent } from './select-symbol-dialog/select-symbol-dialog.component';
import { CapturePhotoDialogComponent } from './capture-photo-dialog/capture-photo-dialog.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    PdftEditorComponent,
    PdftHistoryViewerComponent,
    SelectSymbolDialogComponent,
    CapturePhotoDialogComponent,
  ],
  exports: [PdftHistoryViewerComponent, PdftEditorComponent],
  imports: [CommonModule, SharedModule, FormsModule],
})
export class PdfPdftModule {}
